import "./bootstrap";

import Vue from "vue";
import {createInertiaApp, router} from "@inertiajs/vue2";
import {resolvePageComponent} from "laravel-vite-plugin/inertia-helpers";

import VueTippy, {TippyComponent} from "vue-tippy";

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css"; //Imported via VueSweetalert2
Vue.use(VueSweetalert2);

import CKEditor from "@ckeditor/ckeditor5-vue2";

Vue.use(CKEditor);

import vueGlobalMethods from "./vue-global-methods";

Vue.mixin({
    methods: vueGlobalMethods
});

//Setup Ziggy for Inertia
Vue.prototype.$route = route;

import * as Sentry from "@sentry/vue";

// Uses https://inertiajs.com/events
function inertiaRoutingInstrumentation(
    customStartTransaction,
    startTransactionOnPageLoad = true,
    startTransactionOnLocationChange = true,
) {
    let activeTransaction;
    let name;
    if (startTransactionOnPageLoad) {
        name = route().current();
        activeTransaction = customStartTransaction({
            name,
            op: 'pageload',
            metadata: {
                source: 'route',
            },
        });
    }

    if (startTransactionOnLocationChange) {
        router.on('before', (_to, _from) => {
            if (activeTransaction) {
                activeTransaction.finish();
            }

            const newName = route().current();

            if (newName !== name) {
                activeTransaction = customStartTransaction({
                    name: newName,
                    op: 'navigation',
                    metadata: {
                        source: 'route',
                    },
                });
            }
        });

        router.on('finish', () => {
            activeTransaction.setName(route().current(), 'route');
        });
    }
}

createInertiaApp({
    resolve: name =>
        resolvePageComponent(
            `./pages/${name}.vue`,
            import.meta.glob("./pages/**/*.vue")
        ),
    setup({el, App, props, plugin}) {
        Vue.use(plugin);

        new Vue({
            render: h => h(App, props)
        }).$mount(el);

        const feedbackOptions = {
            showBranding: false,
            useSentryUser: {
                email: "email",
                name: "username",
            },
            showName: false,
            showEmail: false,

        }


        //Sentry
        Sentry.init({
            Vue,
            dsn: import.meta.env.VITE_VUE_DSN,
            environment: import.meta.env.VITE_APP_ENV,
            integrations: [
                Sentry.browserTracingIntegration(),
                (import.meta.env.VITE_APP_ENV === 'test' ? Sentry.feedbackIntegration(feedbackOptions) : ""),
                Sentry.replayIntegration(),
            ],
            tracesSampleRate: (import.meta.env.VITE_APP_ENV === 'live-octane' ? 0.1 : 0.0),

            // Session Replay
            replaysSessionSampleRate: 0.0, // This sets the sample rate at 0%.
            replaysOnErrorSampleRate: 1.0, // 100% when errors occur

            // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ['localhost',
                /^https:\/\/www\.simplyowners\.net\//,
                /^https:\/\/solaravel\.lndo\.site\//,
                /^https:\/\/www\.sodev\.uk\//,
                /^https:\/\/www\.simplybnb\.uk\//,
                /^https:\/\/www\.simplybnb\.co\.uk\//
            ],

            tracingOptions: {
                trackComponents: true
            },

            logErrors: true,
            attachProps: true,
            attachStacktrace: true
        });
        //Sentry Setup End


    }
});


